(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */

/*global define: false Mustache: true*/

(function defineMustache (global, factory) {
  if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
    factory(exports); // CommonJS
  } else if (typeof define === 'function' && define.amd) {
    define(['exports'], factory); // AMD
  } else {
    global.Mustache = {};
    factory(global.Mustache); // script, wsh, asp
  }
}(this, function mustacheFactory (mustache) {

  var objectToString = Object.prototype.toString;
  var isArray = Array.isArray || function isArrayPolyfill (object) {
    return objectToString.call(object) === '[object Array]';
  };

  function isFunction (object) {
    return typeof object === 'function';
  }

  /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */
  function typeStr (obj) {
    return isArray(obj) ? 'array' : typeof obj;
  }

  function escapeRegExp (string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
  }

  /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */
  function hasProperty (obj, propName) {
    return obj != null && typeof obj === 'object' && (propName in obj);
  }

  /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */
  function primitiveHasOwnProperty (primitive, propName) {  
    return (
      primitive != null
      && typeof primitive !== 'object'
      && primitive.hasOwnProperty
      && primitive.hasOwnProperty(propName)
    );
  }

  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
  // See https://github.com/janl/mustache.js/issues/189
  var regExpTest = RegExp.prototype.test;
  function testRegExp (re, string) {
    return regExpTest.call(re, string);
  }

  var nonSpaceRe = /\S/;
  function isWhitespace (string) {
    return !testRegExp(nonSpaceRe, string);
  }

  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
  };

  function escapeHtml (string) {
    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
      return entityMap[s];
    });
  }

  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var equalsRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;

  /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   */
  function parseTemplate (template, tags) {
    if (!template)
      return [];

    var sections = [];     // Stack to hold section tokens
    var tokens = [];       // Buffer to hold the tokens
    var spaces = [];       // Indices of whitespace tokens on the current line
    var hasTag = false;    // Is there a {{tag}} on the current line?
    var nonSpace = false;  // Is there a non-space char on the current line?

    // Strips all whitespace tokens array for the current line
    // if there was a {{#tag}} on it and otherwise only space.
    function stripSpace () {
      if (hasTag && !nonSpace) {
        while (spaces.length)
          delete tokens[spaces.pop()];
      } else {
        spaces = [];
      }

      hasTag = false;
      nonSpace = false;
    }

    var openingTagRe, closingTagRe, closingCurlyRe;
    function compileTags (tagsToCompile) {
      if (typeof tagsToCompile === 'string')
        tagsToCompile = tagsToCompile.split(spaceRe, 2);

      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
        throw new Error('Invalid tags: ' + tagsToCompile);

      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
      closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
      closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
    }

    compileTags(tags || mustache.tags);

    var scanner = new Scanner(template);

    var start, type, value, chr, token, openSection;
    while (!scanner.eos()) {
      start = scanner.pos;

      // Match any text between tags.
      value = scanner.scanUntil(openingTagRe);

      if (value) {
        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
          chr = value.charAt(i);

          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
          } else {
            nonSpace = true;
          }

          tokens.push([ 'text', chr, start, start + 1 ]);
          start += 1;

          // Check for whitespace on the current line.
          if (chr === '\n')
            stripSpace();
        }
      }

      // Match the opening tag.
      if (!scanner.scan(openingTagRe))
        break;

      hasTag = true;

      // Get the tag type.
      type = scanner.scan(tagRe) || 'name';
      scanner.scan(whiteRe);

      // Get the tag value.
      if (type === '=') {
        value = scanner.scanUntil(equalsRe);
        scanner.scan(equalsRe);
        scanner.scanUntil(closingTagRe);
      } else if (type === '{') {
        value = scanner.scanUntil(closingCurlyRe);
        scanner.scan(curlyRe);
        scanner.scanUntil(closingTagRe);
        type = '&';
      } else {
        value = scanner.scanUntil(closingTagRe);
      }

      // Match the closing tag.
      if (!scanner.scan(closingTagRe))
        throw new Error('Unclosed tag at ' + scanner.pos);

      token = [ type, value, start, scanner.pos ];
      tokens.push(token);

      if (type === '#' || type === '^') {
        sections.push(token);
      } else if (type === '/') {
        // Check section nesting.
        openSection = sections.pop();

        if (!openSection)
          throw new Error('Unopened section "' + value + '" at ' + start);

        if (openSection[1] !== value)
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
      } else if (type === 'name' || type === '{' || type === '&') {
        nonSpace = true;
      } else if (type === '=') {
        // Set the tags for the next time around.
        compileTags(value);
      }
    }

    // Make sure there are no open sections when we're done.
    openSection = sections.pop();

    if (openSection)
      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);

    return nestTokens(squashTokens(tokens));
  }

  /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */
  function squashTokens (tokens) {
    var squashedTokens = [];

    var token, lastToken;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];

      if (token) {
        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          squashedTokens.push(token);
          lastToken = token;
        }
      }
    }

    return squashedTokens;
  }

  /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */
  function nestTokens (tokens) {
    var nestedTokens = [];
    var collector = nestedTokens;
    var sections = [];

    var token, section;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];

      switch (token[0]) {
        case '#':
        case '^':
          collector.push(token);
          sections.push(token);
          collector = token[4] = [];
          break;
        case '/':
          section = sections.pop();
          section[5] = token[2];
          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
          break;
        default:
          collector.push(token);
      }
    }

    return nestedTokens;
  }

  /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */
  function Scanner (string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }

  /**
   * Returns `true` if the tail is empty (end of string).
   */
  Scanner.prototype.eos = function eos () {
    return this.tail === '';
  };

  /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */
  Scanner.prototype.scan = function scan (re) {
    var match = this.tail.match(re);

    if (!match || match.index !== 0)
      return '';

    var string = match[0];

    this.tail = this.tail.substring(string.length);
    this.pos += string.length;

    return string;
  };

  /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */
  Scanner.prototype.scanUntil = function scanUntil (re) {
    var index = this.tail.search(re), match;

    switch (index) {
      case -1:
        match = this.tail;
        this.tail = '';
        break;
      case 0:
        match = '';
        break;
      default:
        match = this.tail.substring(0, index);
        this.tail = this.tail.substring(index);
    }

    this.pos += match.length;

    return match;
  };

  /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */
  function Context (view, parentContext) {
    this.view = view;
    this.cache = { '.': this.view };
    this.parent = parentContext;
  }

  /**
   * Creates a new context using the given view with this context
   * as the parent.
   */
  Context.prototype.push = function push (view) {
    return new Context(view, this);
  };

  /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */
  Context.prototype.lookup = function lookup (name) {
    var cache = this.cache;

    var value;
    if (cache.hasOwnProperty(name)) {
      value = cache[name];
    } else {
      var context = this, intermediateValue, names, index, lookupHit = false;

      while (context) {
        if (name.indexOf('.') > 0) {
          intermediateValue = context.view;
          names = name.split('.');
          index = 0;

          /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/
          while (intermediateValue != null && index < names.length) {
            if (index === names.length - 1)
              lookupHit = (
                hasProperty(intermediateValue, names[index]) 
                || primitiveHasOwnProperty(intermediateValue, names[index])
              );

            intermediateValue = intermediateValue[names[index++]];
          }
        } else {
          intermediateValue = context.view[name];

          /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/
          lookupHit = hasProperty(context.view, name);
        }

        if (lookupHit) {
          value = intermediateValue;
          break;
        }

        context = context.parent;
      }

      cache[name] = value;
    }

    if (isFunction(value))
      value = value.call(this.view);

    return value;
  };

  /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */
  function Writer () {
    this.cache = {};
  }

  /**
   * Clears all cached templates in this writer.
   */
  Writer.prototype.clearCache = function clearCache () {
    this.cache = {};
  };

  /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */
  Writer.prototype.parse = function parse (template, tags) {
    var cache = this.cache;
    var cacheKey = template + ':' + (tags || mustache.tags).join(':');
    var tokens = cache[cacheKey];

    if (tokens == null)
      tokens = cache[cacheKey] = parseTemplate(template, tags);

    return tokens;
  };

  /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `tags` argument is given here it must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   */
  Writer.prototype.render = function render (template, view, partials, tags) {
    var tokens = this.parse(template, tags);
    var context = (view instanceof Context) ? view : new Context(view);
    return this.renderTokens(tokens, context, partials, template);
  };

  /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */
  Writer.prototype.renderTokens = function renderTokens (tokens, context, partials, originalTemplate) {
    var buffer = '';

    var token, symbol, value;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      value = undefined;
      token = tokens[i];
      symbol = token[0];

      if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
      else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
      else if (symbol === '>') value = this.renderPartial(token, context, partials, originalTemplate);
      else if (symbol === '&') value = this.unescapedValue(token, context);
      else if (symbol === 'name') value = this.escapedValue(token, context);
      else if (symbol === 'text') value = this.rawValue(token);

      if (value !== undefined)
        buffer += value;
    }

    return buffer;
  };

  Writer.prototype.renderSection = function renderSection (token, context, partials, originalTemplate) {
    var self = this;
    var buffer = '';
    var value = context.lookup(token[1]);

    // This function is used to render an arbitrary template
    // in the current context by higher-order sections.
    function subRender (template) {
      return self.render(template, context, partials);
    }

    if (!value) return;

    if (isArray(value)) {
      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
      }
    } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
    } else if (isFunction(value)) {
      if (typeof originalTemplate !== 'string')
        throw new Error('Cannot use higher-order sections without the original template');

      // Extract the portion of the original template that the section contains.
      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

      if (value != null)
        buffer += value;
    } else {
      buffer += this.renderTokens(token[4], context, partials, originalTemplate);
    }
    return buffer;
  };

  Writer.prototype.renderInverted = function renderInverted (token, context, partials, originalTemplate) {
    var value = context.lookup(token[1]);

    // Use JavaScript's definition of falsy. Include empty arrays.
    // See https://github.com/janl/mustache.js/issues/186
    if (!value || (isArray(value) && value.length === 0))
      return this.renderTokens(token[4], context, partials, originalTemplate);
  };

  Writer.prototype.renderPartial = function renderPartial (token, context, partials) {
    if (!partials) return;

    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
    if (value != null)
      return this.renderTokens(this.parse(value), context, partials, value);
  };

  Writer.prototype.unescapedValue = function unescapedValue (token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return value;
  };

  Writer.prototype.escapedValue = function escapedValue (token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return mustache.escape(value);
  };

  Writer.prototype.rawValue = function rawValue (token) {
    return token[1];
  };

  mustache.name = 'mustache.js';
  mustache.version = '3.0.0';
  mustache.tags = [ '{{', '}}' ];

  // All high-level mustache.* functions use this writer.
  var defaultWriter = new Writer();

  /**
   * Clears all cached templates in the default writer.
   */
  mustache.clearCache = function clearCache () {
    return defaultWriter.clearCache();
  };

  /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */
  mustache.parse = function parse (template, tags) {
    return defaultWriter.parse(template, tags);
  };

  /**
   * Renders the `template` with the given `view` and `partials` using the
   * default writer. If the optional `tags` argument is given here it must be an
   * array with two string values: the opening and closing tags used in the
   * template (e.g. [ "<%", "%>" ]). The default is to mustache.tags.
   */
  mustache.render = function render (template, view, partials, tags) {
    if (typeof template !== 'string') {
      throw new TypeError('Invalid template! Template should be a "string" ' +
                          'but "' + typeStr(template) + '" was given as the first ' +
                          'argument for mustache#render(template, view, partials)');
    }

    return defaultWriter.render(template, view, partials, tags);
  };

  // This is here for backwards compatibility with 0.4.x.,
  /*eslint-disable */ // eslint wants camel cased function name
  mustache.to_html = function to_html (template, view, partials, send) {
    /*eslint-enable*/

    var result = mustache.render(template, view, partials);

    if (isFunction(send)) {
      send(result);
    } else {
      return result;
    }
  };

  // Export the escaping function so that the user may override it.
  // See https://github.com/janl/mustache.js/issues/244
  mustache.escape = escapeHtml;

  // Export these mainly for testing, but also for advanced usage.
  mustache.Scanner = Scanner;
  mustache.Context = Context;
  mustache.Writer = Writer;

  return mustache;
}));

},{}],2:[function(require,module,exports){
var Mustache = require('mustache');

// Resource Search
kmdgResourceCenter = kmdgResourceCenter || {}; // Global object set with wp_localize_script

(function ($) {
    var RC = kmdgResourceCenter;

    RC.fn.initPlayerAPI = RC.fn.initPlayerAPI || function(el) {
        if($(el).hasClass('resource--video-type__vimeo')) {
            var iframe = $(el).find('iframe');

            if(iframe && iframe[0]) {
                var video = new Vimeo.Player(iframe[0]);
                $(el).data('vimeo', video);
                $('.resource--video-jump-list__wrapper').addClass('loaded');
                video.play();
            }
        }
    };

    RC.fn.getSelectedFilters = RC.fn.getSelectedFilters || function() {
        var filters = {};

        RC.$filters.find('select').each(function() {
            var name = $(this).attr('name');

            if($(this).val()) {
                filters[name] = filters[name] || [];
                filters[name].push($(this).val());
            }
        });

        for(var i in filters) {
            if(filters.hasOwnProperty(i)) {
                filters[i] = filters[i].join();
            }
        }

        return filters;
    };

    RC.fn.getPosts = RC.fn.getPosts || function () {
        if(RC.widgetMode) return;

        var options = {
            '_embed': '',
            'page': RC.currentPage,
            'per_page': RC.postsPerPage,
            'orderby': RC.order.mode,
            'order': RC.order.dir,
            'meta_key': RC.order.key,
            'meta_type': RC.order.type
        };

        if(RC.location) {
            options['resource-location'] = RC.location;
        }

        if(RC.$searchBar.val().length >= 3) {
            options.search = RC.$searchBar.val();
        }

        options = $.extend({}, options, RC.fn.getSelectedFilters());

        RC.currentRequest = $.ajax({
            'url': RC.restURL,
            'method': 'GET',
            'data': options,
            'beforeSend': function() {
                RC.$loading.show();

                $(window).trigger('kmdg_rc_loading_posts');

                if(RC.currentRequest != null) {
                    RC.currentRequest.abort();
                }
            }
        }).always(function() {

            RC.currentRequest = null;
            RC.$loading.hide();

        }).fail(function(response) {

            if(response.responseJSON && response.responseJSON.code) {
                RC.$searchResults.html([
                    '<div class="error">',
                    '<h4>There was an error processing your reqest:</h4>',
                    '<p>' + response.responseJSON.message + '</p>',
                    '<p><a href="#/">Click here</a> to reset all filters and try again.</p>',
                    '</div>'
                ].join('\n'));
            }

        }).done(RC.fn.renderPosts);
    };

    RC.fn.setHashData = RC.fn.setHashData || function(key, value, noprefix) {
        var source = window.location;
        var rawhash = '#search';

        if(RC.widgetMode) source = RC.currentLink;

        var hashData = RC.fn.getHashData(source);
        hashData[key] = value;

        if(noprefix && window.location.hash.indexOf(rawhash) === -1) {
            rawhash = "#";
        }

        if(value == undefined || value == null || value == '') {
            delete hashData[key];
        }

        if(!$.isEmptyObject(hashData)) {
            //TODO: Refactor this, it can probably be done with a single loop
            // Order hash properties so that they appear in the URL in the order we want (visual only)
            var properties = [];
            for(var i in hashData) {
                if(hashData.hasOwnProperty(i)) {
                    if(i != 'page') { // everything but page
                        properties.push(i);
                    }
                }
            }

            // put page on the end
            if(hashData['page']) {
                properties.push('page');
            }

            // Create query string
            for(var i in properties) {
                if(properties.hasOwnProperty(i)) {
                    rawhash += '/' + properties[i] + '/' + hashData[properties[i]];
                }
            }
        } else {
            rawhash += '/';
        }

        if(!RC.widgetMode) {
            window.location.hash = rawhash;
            $(RC.currentLink).attr('href', window.location.href);
        } else {
            $(RC.currentLink).attr('href', RC.$searchForm.attr('data-action')+rawhash)
        }

        RC.$searchForm.attr('action', RC.currentLink);
    };

    RC.fn.getHashData = RC.fn.getHashData || function (source) {
        source = source || window.location;
        var rawHash = source.hash.split('/');
        var hashData = {};

        // Loop through the hash creating key/value pairs
        for(var i = 1; i < rawHash.length; i += 2) {
            if(rawHash[i] && rawHash[i+1]) {
                hashData[encodeURIComponent(rawHash[i])] = encodeURIComponent(rawHash[i+1]);
            }
        }

        return hashData;
    };

    RC.fn.getPageNumFromHash = RC.fn.getPageNumFromHash || function () {
        return Number(RC.fn.getHashData().page) || 1;
    };

    RC.fn.setFiltersFromHash = RC.fn.setFiltersFromHash || function () {
        var hashData = RC.fn.getHashData();
        var $selects = RC.$filters.find('select');

        $selects.each(function(i, el) {
            var friendly = $(el).attr('data-friendly');
            if(hashData.hasOwnProperty(friendly)) {
                var $option = $(el).find('option[data-friendly='+hashData[friendly]+']');
                if($option.length > 0) {
                    $(el).val($option.val());
                } else {
                    $(el).val('');
                }
            } else {
                $(el).val('');
            }
        });
    };

    RC.fn.formatDate = RC.fn.formatDate || function (date) {
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();

        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }

        return month + '/' + day + '/' + year
    };

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is true, trigger the function on the
    // leading edge, instead of the trailing.
    RC.fn.debounce = RC.fn.debounce || function(wait, immediate, func) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    RC.fn.renderPosts = RC.fn.renderPosts || function (posts, status, request) {
        var output = '';
        var maxPages = Number(request.getResponseHeader('X-WP-TotalPages'));
        var postIDs = [];

        RC.$loading.hide();

        RC.fn.createPagination(RC.currentPage, maxPages);

        if(posts && posts.length > 0) {
            for(var i in posts) {
                if(posts.hasOwnProperty(i)) {
                    output += RC.fn.renderSinglePost(posts[i]);
                    postIDs.push(posts[i].id);
                }
            }

            RC.$searchResults.html(output);

            $(window).trigger({type:'kmdg_rc_render_posts', 'success': true, 'posts': posts, 'postIDs': postIDs});
        } else {
            RC.$searchResults.html('<div class="resource--search-error">No Resources found. Try refining your search filters.</div>');

            $(window).trigger({type:'kmdg_rc_render_posts', 'success': false});
        }
    };

    RC.fn.renderSinglePost = RC.fn.renderSinglePost || function (post) {
        var imageSrc = null;
        var resourceLink = post.link;
        var resourceDate = post.date;
        var excerpt = '';

        // Pull out embed data (featured image, terms)
        if(post['image']) {
            if(post['image'].thumb) {
                imageSrc = post['image'].thumb;
            } else if(post['image'].full) {
                imageSrc = post['image'].full;
            } else {
                imageSrc = post['image'];
            }
        }

        if(post.excerpt && post.excerpt.rendered && typeof post.excerpt.rendered == 'string') {
            excerpt = post.excerpt.rendered;
        } else if(post.excerpt && typeof post.excerpt == 'string') {
            excerpt = post.excerpt;
        }

        var templateData = {
            'imageSrc': imageSrc,
            'resourceLink': resourceLink,
            'resourceDate': resourceDate,
            'resourceType': post.resourceType.parent.name,
            'excerpt': excerpt,
            'resourceTitle': post.title.rendered || post.title,
            'downloadType' : post.downloadType,
            'resourceDownloadText': post.buttonText
        };

        return Mustache.render(RC.resourceTemplate, $.extend({}, templateData, post['_customMustacheTags']));
    }

    RC.fn.createPagination = RC.fn.createPagination || function (current, max) {
        var show = false;
        var showPrev = true;
        var showNext = true;
        var visibleRange = 2;
        var startPages = current - visibleRange;
        var endPages = current + visibleRange;
        var prevPage = current - 1;
        var nextPage = current + 1;
        var pages = [];

        if(max > 1) {
            show = true;
        }

        if(startPages < 1) {
            startPages = 1;
        }

        if(endPages > max) {
            endPages = max;
        }

        if(prevPage < 1) {
            prevPage = 1;
        }

        if(nextPage > max) {
            nextPage = max;
        }

        if(current == 1) {
            showPrev = false;
        }

        if(current == max) {
            showNext = false;
        }

        for(var i = startPages; i <= endPages; i++) {
            var activeClass = '';

            if(current == i) {
                activeClass = 'current';
            }

            pages.push({
                'page': i,
                'class': activeClass,
            });
        }

        RC.$pagination.html(Mustache.render(RC.paginationTemplate, {
            'show': show,
            'showPrev': showPrev,
            'showNext': showNext,
            'linkBase': RC.paginationLinkBase,
            'firstPage': '1',
            'prevPage': prevPage,
            'pages': pages,
            'nextPage': nextPage,
            'lastPage': max
        }));
    };

    $(document).ready(function() {
        RC.$app = $('.resource--search');
        RC.$searchResults = RC.$app.find('.resource--search-results');
        RC.$searchForm = RC.$app.find('.resource--search-form');
        RC.$searchBar = RC.$app.find('.resource--search-bar').find('[type="search"]');
        RC.$filters = RC.$app.find('.resource--search-filters');
        RC.$loading = RC.$filters.find('.resource--search-loading');
        RC.$pagination = RC.$app.find('.resource--search-pagination');

        RC.widgetMode = RC.$app.is('.resource--widget');
        RC.currentLink = document.createElement('a');
        
        RC.paginationLinkBase = '#/page/';

        RC.resourceTemplate = $(".resource--post-template").html();
        RC.paginationTemplate = $(".resource--pagination-template").html();
        RC.currentPage = RC.fn.getPageNumFromHash();
        RC.currentRequest = null;

        if(RC.$app.length > 0) {

            RC.fn.setHashData('page', RC.currentPage, true);

            RC.$loading.hide().html('<img src="'+RC.loadingGraphic+'" alt="spinner">');

            RC.$searchResults.html([
                '<div class="resource--loading">',
                    '<img src="'+RC.loadingGraphic+'" alt="spinner">',
                    '<span>'+RC.loadingText+'</span>',
                '</div>'
            ].join('\n'));

            Mustache.parse(RC.resourceTemplate);
            Mustache.parse(RC.paginationTemplate);

            RC.fn.setFiltersFromHash();

            RC.fn.getPosts();
        }

        RC.$searchBar.on('keyup', RC.fn.debounce(500, false, function() {
            if($(this).val().length >= 3 || $(this).val().length == 0) {
                RC.fn.setHashData('page', 1);
                RC.fn.getPosts();
            }
        }));

        RC.$filters.find('select').each(function() {
            $(this).on('change', function() {
                RC.fn.setHashData('page', 1);
                RC.fn.setHashData($(this).attr('data-friendly'), $(this).find(':selected').attr('data-friendly'));
                RC.fn.getPosts();
            });
        });

        RC.$searchForm.on('submit', function(e) {

            if(!RC.widgetMode) {
                e.preventDefault();

                //window.location = RC.$searchForm.attr('action');
            }
        });

        $(window).on('hashchange', function(e) {

            if(RC.$searchResults.length > 0) {
                RC.currentPage = RC.fn.getPageNumFromHash();
                RC.fn.setFiltersFromHash();
                RC.fn.getPosts();
                e.preventDefault();
            }

        });

        RC.$pagination.on('click', 'a', function(e) {
            e.preventDefault();

            var page = RC.fn.getHashData(this).page;
            RC.fn.setHashData('page', page);
        });

        $(window).trigger('kmdg_rc_ready', {'RC': RC, 'Mustache': Mustache, 'jQuery': $});
    });

})(jQuery);

// Resource Single
(function($) {

    var $videoPlayer = $('.resource--video-player');

    $(document).on('ready', function() {
        $videoPlayer.each(function(i, el) {
            kmdgResourceCenter.fn.initPlayerAPI(el);
        });
    });

    $(window).on('kmdg_rc_form_submitted', function (event, email, form, callback) {
        console.log(email, form);
        var RC = kmdgResourceCenter;

        if(RC.videoURL && RC.form == form) {
            // When the resource form is submitted and play on page is selected, load the video player iframe
            $videoPlayer.find('.resource--video-wrapper').html('<iframe src="'+ RC.videoURL + '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>');
            $videoPlayer.addClass('loaded');

            $videoPlayer.each(function(i, el) {
                RC.fn.initPlayerAPI(el);
            });

            $.ajax({
                url: RC.ajaxURL,
                method: "GET",
                cache: false,
                data: {
                    action: "kmdg_rc_ajax_video_play",
                    email: email,
                    post_id: RC.resource
                }
            }).done(callback);
        } else {
            $.ajax({
                url: RC.ajaxURL,
                method: "GET",
                cache: false,
                data: {
                    action: "kmdg_rc_ajax_email_file",
                    email: email,
                    post_id: RC.resource
                }
            }).done(callback);
        }
    });


    $('.resource--video-jump-list__item').on('click', function(e) {
        var $player = $('.resource--video-player');

        if($player.data('vimeo')) {
            $player.data('vimeo').setCurrentTime($(this).attr('data-time'));
        }
    });

})(jQuery);

},{"mustache":1}]},{},[2]);
